import { FC, useState, useEffect, useContext } from 'react';
import { PresentMemberRecords } from '../dashboard-hooks';
import Chart from "react-apexcharts";
import ConstantsContext from '../../../../store/Constants-context';

type Props = {
    date: string,
    users: any,
    yearLevel: string,
    customerType: string
}

const PresentMember: FC<Props> = ({date, users = [], yearLevel = "", customerType = ""}) => {
    const constantsCtx = useContext(ConstantsContext)
    const [presentStudents, setPresentStudents] = useState<number>(0);
    const [totalStudents, setTotalStudents] = useState<number>(0);
    const [percent, setPercent] = useState<number[]>([0]);

    useEffect(() => {
        PresentMemberRecords(users, customerType, yearLevel, setPresentStudents, setTotalStudents, setPercent);
    }, [users, date, yearLevel])
    const widgetOptions = JSON.parse('{"options":{"colors":["#009688"],"chart":{"width":"100%","height":60,"type":"radialBar"},"plotOptions":{"radialBar":{"hollow":{"size":"50%"},"dataLabels":{"showOn":"always","name":{"show":true,"color":"#888","fontSize":"13px"},"value":{"offsetY":-5,"color":"#111","fontSize":"26px","show":true}}}},"labels":[""]}}');

    return (
    <div className="col-xxl-3">
        <div className="card card-dashboard card-stretch presentResident">
            <div className='card-body py-9 text-center'>
                <div className="row">
                    <div className="col-md-12">
                        <h5 className="py-0"> Present {constantsCtx.MEMBER_NAME} : </h5>
                        <div className="chart">
                        <Chart options={widgetOptions.options} series={percent} type="radialBar" height="170px" />
                        </div>
                        <h1>{presentStudents} / {totalStudents}</h1>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export {PresentMember};